import { Component, OnInit, Input } from '@angular/core';
import { OrderSummary } from 'src/app/services/api/orders/orders.service';

@Component({
  selector: 'app-order-details-billing',
  templateUrl: './order-details-billing.component.html',
  styleUrls: ['./order-details-billing.component.css']
})
export class OrderDetailsBillingComponent implements OnInit {
  private orderId;

  @Input() summary: OrderSummary;
  @Input() params: any;
  @Input() isps: any[];

  constructor() { }

  ngOnInit() {
  }

}
